import React, { } from "react";
import { Container, Paper } from "@mui/material";
import GridChart from "./GridChart.jsx";
import { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { useEffect } from "react";


const GridChartViewPort = ({
    show,
    clientData,
    client_,
    dataSet_,
    height,
    gridRef,
}) => {


    return (
        <>
            {show && (
                <GridChart
                    height={height}
                    clientData={clientData}
                    client_={client_}
                    dataSet_={dataSet_}
                    gridRef={gridRef}
                />
            )}
        </>
    );
};


// const GridExample = ({ }) => {
//     const [count, setCount] = useState(0)
//     return (
//         <>
//             <button type="button" onClick={() => {
//                 setCount(count + 1);
//             }}>
//                 ParentUseEffect (fails)
//             </button>

//             <GridExampleSub
//                 count={count}
//             />
//         </>
//     )
// }

// const GridExampleSub = ({ count }) => {
//     const [colDefNo, setColDefNo] = useState(0);
//     const [rowData, setRowData] = useState([]);
//     const [columnDefs, setColumnDefs] = useState([]);


//     // update based on prop changing values
//     useEffect(() => {
//         Update()
//     }, [count])

//     const Update = () => {
//         let coldef = Math.abs(colDefNo + 1) % 2
//         setColDefNo(coldef);
//         setRowData(data[coldef])
//         setColumnDefs(colDefs[coldef])

//     }

//     // called in either case
//     const onRowDataUpdated = (event) => {
//         console.log("RowUpdated")
//         event.api.autoSizeAllColumns(false);
//     };


//     const colDefs = [
//         [{ headerName: "Column sdsdsd sdsdsdsA", field: "simple", width: 80, type: "year", pinned: "left" },
//         { headerName: "Column sdsds sdsdsB", field: "simple", width: 80, type: "percent,rightAligned" },
//         { headerName: "Column C C cdcdcdc cd cd cd c d cd c", field: "simple", width: 80, type: "percent,rightAligned" },
//         {
//             "headerName": "Child",
//             "children": [
//                 {
//                     "headerName": "child1",
//                     "children": [
//                         {
//                             "headerName": "child2:ch",
//                             "field": "child2:ch",
//                             "type": "money,rightAligned"
//                         },
//                         {
//                             "headerName": "child3",
//                             "field": "child3:ch",
//                             "type": "money,rightAligned"
//                         }
//                     ]
//                 },
//             ],
//         },
//         ],
//         [{ headerName: "Column A", field: "simple", width: 80 },
//         { headerName: "Column B dfdfdf df BB B B B B B B B ", field: "simple", width: 80 },
//         { headerName: "Column C", field: "simple", width: 80 }],
//     ]

//     const autoSizeStrategy = {
//         type: 'fitCellContents',
//         defaultMinWidth: 80,
//         skipHeader: false,


//     };

//     const data = [
//         [{ simple: 45 },
//         { simple: 455 },
//         { simple: 455, "child2:ch": 33, "child3:ch": 8833, "simple1": 22 },
//         { simple: 5555 }],
//         [{ simple: 425 },
//         { simple: 4552 },
//         { simple: 55525 }],
//     ]


//     return (

//         <div style={{ width: 2000, height: 500 }}>
//             <button
//                 type="button"
//                 onClick={Update}
//             >
//                 Local (works)
//             </button>
//             <div
//                 id="myGrid"
//                 style={{
//                     height: '100%',
//                     width: '100%',
//                 }}
//                 className="ag-theme-alpine"
//             >

//                 <AgGridReact
//                     defaultColDef={{
//                         field: "",
//                         sortable: false,
//                         resizable: true,
//                         suppressMovable: true,
//                         width: 120,
//                         suppressSizeToFit: false,
//                         type: "rightAligned",
//                         wrapHeaderText: true,
//                         autoHeaderHeight: true,
//                     }}
//                     defaultColGroupDef={{
//                         sortable: false,
//                         resizable: true,
//                         width: 120,
//                         type: "rightAligned",
//                     }}

//                     rowData={rowData}
//                     columnDefs={columnDefs}

//                     onRowDataUpdated={onRowDataUpdated}
//                     autoSizeStrategy={autoSizeStrategy}
//                     autoSizePadding={8}

//                 />

//             </div>
//         </div >
//     );
// };


export default GridChartViewPort;
